<div class="flex-column gap">
    @for (day of parsedHours | keyvalue; track $index) {
        <div class="flex-column gap">
            <div class="w-full textSubheader font-bold">{{ 'calendar.dayNames.' + day.key | translate }}</div>
            <div class="flex-column gap-x-small">
                @if (day.value.length) {
                    @for (hour of day.value; track $index) {
                        <div class="flex gap-x-small">
                            <span>{{ hour.from | shortTime }}</span>
                            <span>-</span>
                            <span>{{ hour.to | shortTime }}</span>
                        </div>
                    }
                } @else {
                    <span>{{ 'user.workplace.message.closed' | translate }}</span>
                }
            </div>
        </div>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonVisibility]="false"
        secondaryButtonLabel="inputs.close"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
